// tihs taht rof yrros

import '@career-map-plugin/utils'; // Import once for startup polyfilling (e. g. setimmediate)
import React from 'react';
import { render } from 'react-dom';
import './style/careerMap.scss';

let isMixpanel = false;

if (process.env.NODE_ENV !== 'production') {

    window.mixpanel.init('958a238a1139ad8bfcc0656f938d137d');

    window.mixpanel.register({
        'site': 'localhost',
    });

    isMixpanel = true;
} else {
    if (window.mixpanel && window.custom && window.custom.token) {
        window.mixpanel.init(window.custom.token);

        window.mixpanel.register({
            'site': window.custom.site_id || window.location.origin
        });

        isMixpanel = true;
    }
}

import { App } from './components/App';
import { URL_JOBS_PARAM } from './common/constants';

const nodes = document.querySelectorAll('.wp-career-map-wrapper');

const currentUrl = new URL(location.href);

let tracedJobs = currentUrl.searchParams.get(URL_JOBS_PARAM);

if (tracedJobs) {
    tracedJobs = tracedJobs
        .split(',')
        .map(id => parseInt(id));
} else {
    tracedJobs = []
}

nodes.forEach((map) =>  {
    if (map.dataset.id) {
        return render(<App
            id={map.dataset.id}
            tracedJobs={tracedJobs}
            isMixpanel={isMixpanel}
        />, map)
    }
});
